import { z } from 'zod';
import superjson from 'superjson';
import { QueuePriority, QueuePriorityArrayValues } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type TaskUser = {
  id: number;
  displayName: string;
  avatarUrl: string | null;
};

export type TaskPersona = {
  id: string;
  name: string;
  icon: string;
};

export type TaskItem = {
  id: string;
  title: string;
  description: string | null;
  priority: QueuePriority;
  status: string;
  position: number;
  fileId: string | null;
  createdAt: Date | string | null;
  updatedAt: Date | string | null;
  sessionId: string;
  createdBy: TaskUser;
  assignedTo: TaskUser | null;
  assignedPersona: TaskPersona | null;
};

export type OutputType = {
  tasks: TaskItem[];
};

export const getTasksList = async (input: InputType, init?: RequestInit): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/tasks/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
